import {
  PropsWithChildren,
  ReactNode,
  isValidElement,
  CSSProperties,
} from 'react';

import { GridProps, Tooltip, Typography } from '@mui/material';

import CopyableWrapper from '@/components/ClickToCopy/ViewItemWithCopy';

import { ViewItemRoot } from './styles';

interface ViewItemProps extends PropsWithChildren, GridProps {
  label?: string;
  value?: string | number | boolean | Date | null | ReactNode | any;
  labelStyle?: CSSProperties;
  valueStyle?: CSSProperties;
  children?: ReactNode;
  valueAsTooltip?: boolean;
  copyable?: boolean;
  showMapsIcon?: boolean;
  endAdornment?: ReactNode;
  getCopyValue?: () => Promise<string>;
  persistentActions?: ReactNode;
}

export const ViewItem = ({
  label,
  value,
  direction = 'row',
  labelStyle,
  valueStyle,
  children,
  valueAsTooltip,
  copyable = false,
  showMapsIcon = false,
  endAdornment,
  getCopyValue,
  persistentActions,
  ...rest
}: ViewItemProps) => {
  const plainValue = isValidElement(value) ? '' : value?.toString() ?? '';

  return (
    <ViewItemRoot
      xs={12}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'baseline',
      }}
      direction={direction}
      {...rest}
      container
      item
    >
      {copyable ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <CopyableWrapper
            label={label || ''}
            value={isValidElement(value) ? (value as any) : plainValue}
            showMapsIcon={showMapsIcon}
            getCopyValue={getCopyValue}
            persistentActions={persistentActions}
          />
          {endAdornment}
        </div>
      ) : (
        <>
          {label && (
            <Typography className="label" style={labelStyle}>
              {label}
            </Typography>
          )}

          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            {value !== null &&
              value !== undefined &&
              (valueAsTooltip ? (
                <Tooltip title={plainValue}>
                  <Typography
                    className={`value${
                      label?.toLowerCase() === 'email address'
                        ? ' is--email'
                        : ''
                    }`}
                    style={{
                      ...valueStyle,
                      ...{
                        fontSize: '14px',
                        wordBreak: 'break-word',
                        width: 125,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      },
                    }}
                  >
                    {isValidElement(value) ? value : plainValue}
                  </Typography>
                </Tooltip>
              ) : (
                <Typography
                  className={`value${
                    label?.toLowerCase() === 'email address' ? ' is--email' : ''
                  }`}
                  style={{ ...valueStyle, wordBreak: 'break-word' }}
                >
                  {isValidElement(value) ? value : plainValue}
                </Typography>
              ))}
            {endAdornment}
          </div>
        </>
      )}

      {children}
    </ViewItemRoot>
  );
};

export default ViewItem;
